<template>
  <div>
    <CollectionView endpoint="admin/communities" searchable :orderable="[{key: 'name', name: localization.translate('name')}, {key: 'type', name: localization.translate('type')}]" v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("communities") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table" style="white-space: nowrap">
              <div class="table-header">
                <div class="table-header-cell">{{ localization.translate("name") }}</div>
                <div class="table-header-cell">{{ localization.translate("type") }}</div>
                <div class="table-header-cell">{{ localization.translate("custom.domain") }}</div>
                <div class="table-header-cell">{{ localization.translate("domain") }}</div>
                <div class="table-header-cell">{{ localization.translate("owner") }}</div>
                <div class="table-header-cell">{{ localization.translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <ButtonView type="link" color="foreground" :route="{ name: 'community', params: { communityId: item.id }}">
                      <div class="d-flex align-items-center g-2">
                        <img v-if="item.logoUrl" class="rounded-1" :src="item.logoUrl" style="max-height: 1em; max-width: 1em"/>
                        <span class="fw-bold text-break">{{ item.name }}</span>
                      </div>
                    </ButtonView>
                  </div>
                  <div class="table-column">
                    <img class="rounded-1" :src="item.type.iconUrl" style="max-height: 1em; max-width: 1em"/>
                  </div>
                  <div class="table-column">
                    {{ item.domain }}
                  </div>
                  <div class="table-column">
                    {{ item.subdomain }}
                  </div>
                  <div class="table-column">
                    <UserView :user="item.owner"/>
                  </div>
                  <div class="table-column">
                    <TargetedModalHttpFormView v-if="authorization.adminRole(adminRoles.superAdmin)" size="small" :endpoint="utilities.path('admin/communities/@', item.id)" method="delete" @success="reload = true">
                      <template v-slot:target="{ show }">
                        <ButtonView type="soft" color="danger" size="small" @click="show">
                          <i class="fas fa-trash"></i>
                        </ButtonView>
                      </template>
                      <template v-slot:form="{ content, submit, loading, hide }">
                        <CheckboxInputView :title="translate('confirm')" color="danger" v-model:value="content.confirmed"/>
                        <SpinnerView :active="loading" color="danger"/>
                        <div class="d-flex align-items-center g-4 mt-4">
                          <ButtonView type="normal" color="danger" class="w-100" :disabled="!content.confirmed" @click="submit">
                            {{ translate("delete") }}
                          </ButtonView>
                          <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                            {{ translate("cancel") }}
                          </ButtonView>
                        </div>
                      </template>
                    </TargetedModalHttpFormView>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
  </div>
</template>

<script>
import {CollectionView, ButtonView, utilities, CheckboxInputView, SpinnerView, TargetedModalHttpFormView} from "@/niftybit";
import localization from "../../localization";
import UserView from "@/components/other/UserView.vue";
import authorization from "@/authorization";
import {adminRoles} from "@/systems/main/adminRoles";

export default {
  name: "CommunitiesView",
  computed: {
    utilities() {
      return utilities
    },
    adminRoles() {
      return adminRoles
    },
    authorization() {
      return authorization
    },
    localization() {
      return localization
    }
  },
  components: {SpinnerView, UserView, CheckboxInputView, CollectionView, ButtonView, TargetedModalHttpFormView},
  data() {
    return {
      reload: false
    }
  }
}
</script>

<style scoped>

</style>
